module.exports = __webpack_public_path__ + "static/media/express.56d604ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/express.png
// module id = 161
// module chunks = 0